import React from 'react';
import { useLocation } from 'react-router-dom';
import './MyProjects.css';
import gun_broker from '../../images/gun_broker.png';
import shoe_zone from '../../images/shoe_zone.png';
import travel_kit from '../../images/travel_kit.png';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';


const MyProjects = () => {

    return (
        <div className='projects_section'>
            <div className='single__project'>
                <Zoom>
                    <div className='project__image'  >
                        <img src={gun_broker} alt="" />

                        <a href="https://gun-broker.web.app/" target="_blank" rel="noopener noreferrer"> <button className='project_btn'>Live site</button></a>

                        <a href="https://github.com/naime-ahmed/gun-broker-client-side" target="_blank" rel="noopener noreferrer"><button className='project_btn'>Code</button></a>

                    </div>
                </Zoom>
                <div className='project__text' >
                    <Fade top>
                        <ul>
                            <li>GUN BROKER is the fully responsive full stack niche web app. Here users can can order a product. If users aren't logged in, he/she will be redirect to login page. After login, user can place her selected order. When order will be placed, it will be show in her/his dashboard. If user want, he/she can delete the order.</li>
                            <li>
                                There is a Dashboard route which is protected from any random user. For access Dashboard route, user must be logged in but logged in user can't see admin route he/she only see and access user route. only admin can see and access admin route. From dashboard, user can give review to this web page. The review will be show in the home page. 
                            </li>
                            <li>
                                Admin can control this web page from her/his Dashboard. Admin can delete or approved all order whose user placed. Admin can make an admin an another existing user. Admin also can add product in this web site. After adding product, the product will appear in the All Product page. If admin want, they can delete product from all product page. 
                            </li>
                        </ul>
                    </Fade>
                </div>
            </div>
            <div className='single__project'>
                <Zoom>
                    <div className='project__image' >
                        <img src={shoe_zone} alt="" />

                        <a href="https://shoe-zoon.web.app/" target="_blank" rel="noopener noreferrer"><button className='project_btn'>Live site</button></a>

                        <a href="https://github.com/naime-ahmed/shoe-zoon" target="_blank" rel="noopener noreferrer"><button className='project_btn'>Code</button></a>
                    </div>
                </Zoom>
                <div className='project__text' >
                    <Fade top delay={1000}>
                        <ul>
                            <li>She zone is one kind of simple e-commerce based web app. Here users can see some products on Home page, also he/she can see all product on All product page. Users can order any product from both page. Before order the product, users must be logged in.  Without logged in user can't order products. Because order placed route is protected from unknown users.</li>
                            <li>
                                After Ordered the product, the product will appear on the my orders page. On my order page, users only see his/her orders. If users want, she/he can delete any order from the order list. We store all user information on our database for manage all user.
                            </li>
                            <li>
                                There is a Dashboard for Admin. From dashboard admin can manage all users orders. Admin can approved or delete order from dashboard. Admin also can add product on all product page from add product section. admin also can make  Admin another existing user.  
                            </li>
                        </ul>
                    </Fade>
                </div>
            </div>
            <div className='single__project'>
                <Zoom>
                    <div className='project__image' >
                        <img src={travel_kit} alt="" />

                        <a href="https://travel-kitt.web.app/" target="_blank" rel="noopener noreferrer"><button className='project_btn'>Live site</button></a>

                        <a href="https://github.com/naime-ahmed/travel-kit" target="_blank" rel="noopener noreferrer"><button className='project_btn'>Code</button></a>
                        
                    </div>
                </Zoom>
                <div className='project__text'>
                    <Fade top>
                        <ul>
                            <li>Travel kit is MERN stack base web application where I applied CRUD operation for add, update, delete and post information on the web page. user can see some ticket card on home page. User can order ticket from home page. But users must be logged in before order the product. Because the place order page is protected from random users.</li>
                            <li>
                                When user ordered her/his product, the product will appear on the her/his dashboard. User can see only her/his order and also can delete any order from my order list.   
                            </li>
                            <li>
                                On Dashboard, there are some page for Admin which is protected from all users. Admin manage All users orders from manage all order page. Admin can delete or approve the any order. Admin also can add product from add product dashboard. Also admin can manage all product from dashboard. 
                            </li>
                        </ul>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default MyProjects;